$(document).ready(function () {

    const hour = new Date().getHours();

    if(hour < 9 || hour >= 21){
        $(".sticky_interior_design_wrapper").removeClass("show_btn_desktop");
        $(".sticky_interior_design_wrapper_mobile").removeClass("show_btn_mobile");
    }else{
        $(".sticky_interior_design_wrapper").addClass("show_btn_desktop");
        $(".sticky_interior_design_wrapper_mobile").addClass("show_btn_mobile");
    }

});
